import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { LParagraph } from '@finect/tabular-core/LParagraph';
import { GridCol } from '../GridCol';
import { CardInner, Title } from './partials';
var IconCard = function IconCard(props) {
  return React.createElement(GridCol, {
    cols: 4,
    className: props.className
  }, React.createElement(CardInner, null, props.icon, React.createElement(Title, null, props.title), React.createElement(LParagraph, {
    size: "large"
  }, props.children)));
};
export default styled(IconCard).withConfig({
  displayName: "IconCard",
  componentId: "sc-1vk2hpo-0"
})(["padding-top:8px;padding-bottom:8px;", ";svg{width:80px;height:80px;margin-bottom:40px;}", ";"], minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: -8px;\n    margin-bottom: -8px;\n  "]))), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-top: 16px;\n    padding-bottom: 16px;\n\n    svg {\n      width: 56px;\n      height: 56px;\n      margin-bottom: 32px;\n    }\n\n    p:not([class*='Title']) {\n      font-size: 14px;\n      line-height: 24px;\n    }\n\n    img {\n      width: 56px;\n      height: 56px;\n      margin-bottom: 32px;\n    }\n  "]))));